export default __webpack_public_path__ + "static/project-slide-5-2016-765-fa49124c54abb780ea23ac8d780d246c.jpg";